import {IMedialDimensions} from '../../types/app.types';

export const THUMBNAIL_DIMENSIONS: IMedialDimensions = {
  width: 100,
  height: 100,
};
export const MAX_PRODUCT_OPTION_LENGTH = 500;

export enum StyleParam {
  ShowOrderNumber = 'THANK_YOU_PAGE_ORDER_NUMBER_SELECTION',
  ShowImage = 'THANK_YOU_PAGE_IMAGE_SELECTION',
  ShowContinueBrowsingLink = 'THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_SELECTION',
}

export const BI_APP_NAME = 'Stores';

export const BI_ORIGIN = 'thank you page';

export enum FedopsInteractions {
  GET_ORDER = 'wix-code-get-order',
}

export enum ProductType {
  Physical = 'physical',
  Digital = 'digital',
  Service = 'service',
  GiftCard = 'gift_card',
}

export enum DeliveryType {
  SHIPPING = 'SHIPPING',
  PICKUP = 'PICKUP',
}

export const ORDER_FETCH_ATTEMPTS = 4;

export enum Specs {
  HideOrderNumberWhenNotValid = 'specs.stores.HideOrderNumberWhenNotValid',
  ShowDeliveryTimeInTYP = 'specs.stores.ShowDeliveryTimeInTYP',
  shouldChangeToBiCatalogV2 = 'specs.stores.shouldChangeToBiCatalogV2',
  EnhancePurchaseEvent = 'specs.stores.EnhancePurchaseEvent',
  SendMarkCheckoutAsCompletedWithOrderIdFromTYP = 'specs.stores.SendMarkCheckoutAsCompletedWithOrderIdFromTYP',
  UpdateOrderModelWithSubscriptionInfo = 'specs.stores.TYPUpdateOrderModelWithSubscriptionInfo',
  AddSubscriptionInfoToOrderQuery = 'specs.stores.AddSubscriptionInfoToOrderQuery',
  AddOrderIdToMarkCheckoutAsCompleted = 'specs.stores.AddOrderIdToMarkCheckoutAsCompleted',
  UseGetSettingsWithDefaults = 'specs.stores.UseGetSettingsWithDefaults',
}

export const ADD_TO_CALENDAR_ACTION_ID = 'ADD_TO_CALENDAR';
